import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

const ContactTwo = (props) => {
  const { itemClass } = props;
  const formRef = useRef();

  const [popup, setPopup] = useState({
    open: false,
    title: '',
    message: '',
    type: 'info' // 'success' | 'error' | 'warning' | 'info'
  });

  const closePopup = () => setPopup((p) => ({ ...p, open: false }));

  const handleSubmit = (e) => {
    e.preventDefault();
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    if (!serviceId || !templateId || !publicKey) {
      setPopup({
        open: true,
        title: 'Uyarı',
        message: 'Form gönderimi şu anda aktif değil. Lütfen bizimle doğrudan iletişime geçin.',
        type: 'warning'
      });
      return;
    }

    emailjs
      .sendForm(serviceId, templateId, formRef.current, { publicKey })
      .then(
        () => {
          setPopup({
            open: true,
            title: 'Başarılı',
            message: 'Mesajınız başarıyla gönderildi!',
            type: 'success'
          });
          formRef.current.reset();
        },
        (error) => {
          console.error('EmailJS error:', error);
          setPopup({
            open: true,
            title: 'Hata',
            message: 'Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.',
            type: 'error'
          });
        }
      );
  };

  const colorByType = (type) => {
    if (type === 'success') return '#16a34a';
    if (type === 'error') return '#dc2626';
    if (type === 'warning') return '#f59e0b';
    return '#2a3658';
  };

  return (
    <div
      className={
        itemClass
          ? itemClass
          : 'contact__area contact__plr-2 mt-100 mb-100 p-relative fix'
      }
      style={{ backgroundColor: '#ffffff' }}
    >
      <div className="contact__border">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-8 col-lg-7">
              <div className="contact__section-title pb-10">
                <h4 className="section-subtitle">İletişime Geç</h4>
                <h3 className="section-title">
                  Sizi Dinlemek İsteriz
                </h3>
              </div>
              <div className="contact__form">
                <form ref={formRef} onSubmit={handleSubmit}>
                  <input type="hidden" name="to_email" value="info@gemasan.com.tr" />
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="postbox__contact-input">
                        <input type="text" name="name" placeholder="Ad Soyad *" required />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="postbox__contact-input">
                        <input type="email" name="email" placeholder="E-Mail *" required />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="postbox__contact-input">
                        <input type="tel" name="phone" placeholder="Telefon *" required />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="postbox__contact-input">
                        <input type="text" name="subject" placeholder="Konu *" required />
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="postbox__contact-textarea">
                        <textarea name="message" placeholder="Mesajınız... *" required></textarea>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="contact__button" style={{ marginTop: '30px', textAlign: 'center' }}>
                        <button
                          type="submit"
                          className="main-btn-sm tp-btn-hover alt-color"
                          style={{
                            backgroundColor: '#2a3658',
                            color: '#ffffff',
                            padding: '15px 40px',
                            borderRadius: '30px',
                            border: 'none',
                            cursor: 'pointer',
                            fontWeight: '600',
                            fontSize: '16px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            transition: 'all 0.3s ease'
                          }}
                        >
                          <span style={{ display: 'block', textAlign: 'center' }}>Gönder</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-xl-4 col-lg-5">
              <div className="contact__left-side">
                <div
                  className="contact__item"
                  style={{
                    backgroundColor: '#2a3658',
                    border: '2px solid #2a3658',
                    borderRadius: '15px',
                    padding: '20px',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <div
                    style={{
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                      backgroundColor: '#ffffff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '20px',
                      flexShrink: 0
                    }}
                  >
                    <i className="fal fa-phone-alt" style={{ color: '#2a3658', fontSize: '20px' }}></i>
                  </div>
                  <div className="contact__content">
                    <h4 className="contact__title-sm" style={{ color: '#ffffff', marginBottom: '5px', fontWeight: '600' }}>
                      Telefon
                    </h4>
                    <span style={{ color: '#ffffff' }}>
                      <a href="tel:+905313008336" style={{ color: '#ffffff', textDecoration: 'none' }}>
                        0 (531) 300 83 36
                      </a>
                    </span>
                  </div>
                </div>
                <div
                  className="contact__item"
                  style={{
                    backgroundColor: '#2a3658',
                    border: '2px solid #2a3658',
                    borderRadius: '15px',
                    padding: '20px',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <div
                    style={{
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                      backgroundColor: '#ffffff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '20px',
                      flexShrink: 0
                    }}
                  >
                    <i className="fal fa-envelope-open-text" style={{ color: '#2a3658', fontSize: '20px' }}></i>
                  </div>
                  <div className="contact__content">
                    <h4 className="contact__title-sm" style={{ color: '#ffffff', marginBottom: '5px', fontWeight: '600' }}>
                      E-Posta
                    </h4>
                    <span style={{ color: '#ffffff' }}>
                      <a href="mailto:info@gemasan.com.tr" style={{ color: '#ffffff', textDecoration: 'none' }}>
                        info@gemasan.com.tr
                      </a>
                    </span>
                  </div>
                </div>
                <div
                  className="contact__item"
                  style={{
                    backgroundColor: '#2a3658',
                    border: '2px solid #2a3658',
                    borderRadius: '15px',
                    padding: '20px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <div
                    style={{
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                      backgroundColor: '#ffffff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '20px',
                      flexShrink: 0
                    }}
                  >
                    <i className="fal fa-map-marker-check" style={{ color: '#2a3658', fontSize: '20px' }}></i>
                  </div>
                  <div className="contact__content">
                    <h4 className="contact__title-sm" style={{ color: '#ffffff', marginBottom: '8px', fontWeight: '600' }}>
                      Konum
                    </h4>
                    <div style={{ color: '#ffffff', lineHeight: '1.6' }}>
                      Üniversite Mah. Hastane Cad. No:1913 Ortahisar/Trabzon
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {popup.open && (
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="popup-title"
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0,0,0,0.45)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
          }}
          onClick={closePopup}
        >
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '14px',
              width: 'min(90vw, 480px)',
              boxShadow: '0 15px 40px rgba(0,0,0,0.2)',
              overflow: 'hidden',
              transform: 'translateY(0)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                backgroundColor: colorByType(popup.type),
                color: '#ffffff',
                padding: '14px 18px',
                fontWeight: 700
              }}
            >
              <span id="popup-title">{popup.title}</span>
            </div>
            <div style={{ padding: '18px 18px 8px 18px', color: '#2a3658' }}>
              <p style={{ margin: 0 }}>{popup.message}</p>
            </div>
            <div style={{ padding: '0 18px 18px 18px', display: 'flex', justifyContent: 'flex-end' }}>
              <button
                onClick={closePopup}
                style={{
                  backgroundColor: '#2a3658',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '10px 16px',
                  cursor: 'pointer',
                  fontWeight: 600
                }}
              >
                Tamam
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactTwo;
